import { render, staticRenderFns } from "./RelatedTicket.vue?vue&type=template&id=2dfdfbf4&scoped=true&"
import script from "./RelatedTicket.vue?vue&type=script&lang=js&"
export * from "./RelatedTicket.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTicket.vue?vue&type=style&index=0&id=2dfdfbf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdfbf4",
  null
  
)

export default component.exports